export enum FeatureGroupType {
  NOT_AVAILABLE = 'N/A',
  USER = 'user-plan-license',
  TEAM = 'team-plan-license',
}

export interface FeatureGroup {
  id?: string
  slug: FeatureGroupType.USER | FeatureGroupType.TEAM | FeatureGroupType.NOT_AVAILABLE
  label?: string
  features?: string[]
}
